import produce from "immer";
import {
  GET_PERMISSION,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_ERROR,
} from "./constants";

export const initialState = {
  role: null,
  permissions: {},
  loading: false,
  error: null,
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_PERMISSION:
        draft.loading = true;
        draft.error = null;
        break;
      case GET_PERMISSION_SUCCESS:
        draft.loading = false;
        draft.role = action.payload.role;
        draft.permissions = action.payload.permissions;
        break;
      case GET_PERMISSION_ERROR:
        draft.loading = false;
        draft.error = action.payload;
        break;
      default:
        break;
    }
  });

export default reducer;
